import useMedia from 'utils/hooks/useMedia';
import { useAppSelector } from 'state/store-hooks';
import { SELECTION_DROPDOWN_MOBILE_QUERY } from '../SelectionDropdown/selectionDropdownTypes';

export const COUNTRY_SELECTOR_MOBILE_QUERY = SELECTION_DROPDOWN_MOBILE_QUERY;

/** Layouts that open the desktop dropdown; every other layout keeps the bottom sheet on all viewports. */
export const COUNTRY_SELECTOR_DROPDOWN_LAYOUTS: ReadonlyArray<string> = ['panoramic'];

export type CountrySelectorVariant = 'sheet' | 'dropdown';

export const resolveCountrySelectorVariant = ({
  isMobile,
  layout,
}: {
  isMobile: boolean;
  layout?: string | null;
}): CountrySelectorVariant => {
  if (isMobile) return 'sheet';
  return COUNTRY_SELECTOR_DROPDOWN_LAYOUTS.includes(layout || '') ? 'dropdown' : 'sheet';
};

export const useCountrySelectorVariant = (): CountrySelectorVariant => {
  const isMobile = useMedia(COUNTRY_SELECTOR_MOBILE_QUERY);
  const layout = useAppSelector(
    (state: any) => state?.initTheme?.theme_editor_settings?.customization_settings?.layout,
  );
  return resolveCountrySelectorVariant({ isMobile, layout });
};
